// Marca usada quando nao foi possivel resolver a marca da rota ou do localStorage.
export const DEFAULT_BRAND_NAME = 'spott';
